import { useEffect } from 'react';
import {
  SCORE_CONTAINER_CLASS_NAME, SCORE_VALUE_CLASS_NAME,
} from '@/components/shared/Froala/plugins/TextVariable/TextVariablePopover/TotalSlideShowScore/TotalSlideShowScore.utils';

const replaceFirstNumberInElement = (element: Element, newNumber: number) => {
  const replaceInNode = (node: Element | ChildNode) => {
    if (node.nodeType === Node.TEXT_NODE) {
      const replaced = node.textContent
        .replace(/\[score]/, () => String(newNumber))
        .replace(/-?\d+(\.\d+)?/, () => String(newNumber));

      if (replaced !== node.textContent) {
        // eslint-disable-next-line no-param-reassign
        node.textContent = replaced;
      }
    }

    return Array.from(node.childNodes).find(child => replaceInNode(child)) !== undefined;
  };

  replaceInNode(element);
};

export const useUpdateTotalSlideShowScore = (score: number, isPresentMode: boolean, dependencies?: any[]) => {
  useEffect(() => {
    if (!isPresentMode) return;
    if (score == null) return;

    document.querySelectorAll(`.${SCORE_CONTAINER_CLASS_NAME}`).forEach((element) => {
      const valueElement = element.querySelector(`.${SCORE_VALUE_CLASS_NAME}`);
      replaceFirstNumberInElement(valueElement, score);
    });
  }, [score, ...dependencies || []]);
};

export default useUpdateTotalSlideShowScore;
